<auth-page-layout title="Welcome to the {{agency?.name}} Patient Portal"
  [logoUrl]="agency?.logoUrl"
  cardTitle="Forgot Password" illustration="assets/illustration-sign-in.png">
  <form>
    <div class="form-group">
      <label for="pwreset_req_email">Email address</label>
      <input id="pwreset_req_email" name="pwreset_req_email" type="email" [(ngModel)]="email" (keyup.enter)="reset()"
        autofocus class="form-control" aria-describedby="emailHelp" placeholder="you@emailprovider.com">
    </div>
    <button (click)="reset()" type="button" class="btn btn-primary btn-block">Send Password Reset</button>
    <small class="form-text text-muted mt-3">If you're account exists, you will be receive an email with
      instructions to reset your password</small>
  </form>
</auth-page-layout>
